import { reducer as organizationReducer } from './organization/reducer'
import { reducer as programReducer } from './program/reducer'
import { reducer as linksReducer } from './links/reducer'
import { reducer as locationReducer } from './location/reducer'
import { reducer as systemReducer } from './systemReducer'

const reducers = [
  programReducer,
  organizationReducer,
  linksReducer,
  systemReducer,
  locationReducer,
]

export default function (state, action) {
  return reducers.reduce((acc, reducer) => reducer(acc, action), state)
}
